import { Props as ApexProps } from 'react-apexcharts';

export const options: ApexProps['options'] = {
    labels: ['Нарушение', 'Мьют', 'Бан', 'Кик'],
    legend: {
        show: true,
        position: 'left',
    },
    plotOptions: {
        pie: {
            expandOnClick: false,
        },
    },
    theme: {
        monochrome: {
            enabled: true,
            color: '#597EF7',
        },
    },
};
